// extracted by mini-css-extract-plugin
export var button = "_hi-0";
export var donut = "_hi-1";
export var donutFill = "_hi-3";
export var donutTrack = "_hi-2";